import React from 'react'
import { getRelativeServiceBasePath } from '../../../global/environments/path'

function LoadingIndicator() {
  return (
    <div
      className="Modal Modal--light"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDesc"
    >
      <section className="Modal-window u-decoShadowReset u-bgColorTransparent">
        <div className="Modal-content Content" id="modalDesc">
          <div className="Loading">
            <div className="Loading-indicator Loading--circle u-textCenter">
              <img
                src={
                  getRelativeServiceBasePath() +
                  `/webfiles/latest/assets/cti/images/cti-page-loader-icon.gif`
                }
                aria-label="Loading"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default LoadingIndicator
